import { render } from "./Dac7Tab.vue?vue&type=template&id=2b14cdbc&scoped=true"
import script from "./Dac7Tab.vue?vue&type=script&lang=js"
export * from "./Dac7Tab.vue?vue&type=script&lang=js"

import "./Dac7Tab.vue?vue&type=style&index=0&id=2b14cdbc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b14cdbc"]])

export default __exports__